import React from 'react';
import { MultiSessionDeviceSubs } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionSubscriptions';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { type BillingDataSubscriptionInfo, isImapSubscription } from 'reactApp/modules/billingData/billingData.types';
import {
    BeforeRenderModalTexts,
    ImapAsPaidFeatureTexts,
    MultiSessionFreeChoiceModalTexts,
    MultiSessionPresetInSubsTexts,
} from 'reactApp/ui/BeforeRenewModal/BeforeRenewModal.helpers';

import styles from './BeforeRenewModal.css';

export interface BeforeRenewModalProps {
    onClose?(): void;
    onClick?(): void;
    onCancel?(): void;
    onShow?(): void;
    subscription: BillingDataSubscriptionInfo;
}

export function BeforeRenewModal({ onShow, onCancel, onClick, onClose, subscription }: BeforeRenewModalProps) {
    const productId = subscription.productId;
    let modalInfo = BeforeRenderModalTexts;
    /* tempexp_20439-start */
    if (productId && MultiSessionDeviceSubs.enabled) {
        if (MultiSessionDeviceSubs.isFreeChoiceProduct(productId)) {
            modalInfo = MultiSessionFreeChoiceModalTexts;
        }
        if (MultiSessionDeviceSubs.isPresetInSubsProduct(productId)) {
            modalInfo = MultiSessionPresetInSubsTexts;
        }
    }
    /* tempexp_20439-end */

    /* tempexp_20582-start */
    if (productId && isImapSubscription(subscription)) {
        modalInfo = ImapAsPaidFeatureTexts;
    }
    /* tempexp_20582-end */

    return (
        <BaseConfirmDialog
            dataQAId="before-renew-modal"
            className={styles.dialog}
            onSuccess={onClick}
            onAction={onCancel}
            onShow={onShow}
            onClose={onClose}
            renderHeader={() => (
                <span className={styles.title}>
                    {modalInfo.getTitle(subscription)}
                    <br />
                    {modalInfo.getTitleQuestion(subscription)}
                </span>
            )}
            renderContent={() => (
                <span className={styles.content}>
                    {modalInfo.getContentText(subscription)}
                    <br />
                    {modalInfo.getContentRenewalText(subscription)}
                </span>
            )}
            size="average"
            buttonTheme="vk"
            buttons={[EButtonType.accept, EButtonType.action]}
            successButtonText="Продлить"
            actionButtonText="Не продлевать"
        />
    );
}
